import { BASE_ARB_AGREEMENT_PATH, FINWISE } from './Constants';
import { postData } from 'helpers/RequestHelper';
import validations from 'validations/validations';

export const jukeboxRequest = async (
  email,
  state,
  ssn,
  hideSsn,
  sourceType,
  firstName,
  lastName,
  zip
) => {
  const ssnIsValid =
    hideSsn ||
    !validations.socialSecurityNumber({
      socialSecurityNumber: ssn
    }).socialSecurityNumber;
  if (state && ssnIsValid) {
    const res = await postData({
      url: '/register/check_cobranding',
      body: {
        email,
        state,
        grossMonthlyIncome: '',
        loanAmount: '',
        ssn,
        source_type: sourceType,
        first_name: firstName,
        last_name: lastName,
        zip_code: zip
      }
    });
    const code = res.data.id;
    const owner = res.data.owner;
    const turnupVendor = res.data.turnup_vendor;
    const mailOfferEvent = res.data.mail_offer_event;
    const minLoanAmount = res.data.min_loan_amount;
    const maxLoanAmount = res.data.max_loan_amount;

    if (mailOfferEvent) {
      window.trackAttributionTouch({ Other_type: mailOfferEvent });
    }

    const body = document.getElementsByTagName('body')[0];
    body.className = owner;
    if (state === 'CA') {
      body.className += ' california';
    }

    // update arb agreement with the owner
    const arbAgreementFrame = window.$('.arbitration-frame')[0];
    const queryParams = `state=${state}&finwise=${
      owner === FINWISE
    }&bank=${owner}`;
    const newSrc = `${BASE_ARB_AGREEMENT_PATH}?${queryParams}`;
    if (arbAgreementFrame && arbAgreementFrame.src.indexOf(newSrc) < 0) {
      arbAgreementFrame.src = newSrc;
    }

    return { code, owner, turnupVendor, minLoanAmount, maxLoanAmount };
  }
  return {};
};
